export default function getResource(label, vars = []) {
    const resources = {
        freeReturnsBannerPrefix: 'Gratuit',
        freeReturnsBannerSuffix: ' Retours en magasin ou en ligne dans un délai de 30 jours*',
        freeReturnsInfoAriaLabel: 'Détails de la politique de retour',

        freeShippingCardTitle: 'Expédition gratuite',
        fastDelivery: 'Livraison rapide',
        sameDayDelivery: 'Livraison le jour même',
        pickupCardTitle: 'Ramassage',

        pickupCardEta: 'Dès aujourd’hui',
        fastDeliveryCardEta: 'Dès aujourd’hui',
        cardEtaDeliveryBy: 'Livraison par',

        asSoonAsToday: 'As soon as today',
        asSoonAsTomorrow: 'As soon as tomorrow',
        asSoonAs: `As soon as ${vars[0]}`,

        availableInAllStoresCardTitle: 'Offert dans tous les magasins',
        onlineOnly: 'Online Only',
        fastDeliveryNotAvailable: 'Non disponible pour cet article',
        pickupNotAvailable: 'Non disponible pour le ramassage',

        for: 'for',
        yourLocation: 'your location',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        limitedStock: 'Limited Stock',
        selectForStoreAvailability: 'Select to see availability',
        notAvailable: 'Not available',
        fastDeliveryNotAvailableForZip: 'Fast Delivery not available',
        fastDeliveryPanelZipAriaLabel: 'Change delivery location',
        fastDeliveryPanelInfoAriaLabel: 'About Fast Delivery',

        sddRougeTestV2Message: `As a Rouge member, you're only ${vars[0]} away from FREE Same-Day Delivery.`,
        sddRougeTestV2FreeShippingMessage: 'As a Rouge member, you\'re getting FREE Same-Day Delivery.',
        fastDeliveryRougeTestV2Message: `As a Rouge member, you're only ${vars[0]} away from FREE Fast Delivery.`,
        fastDeliveryRougeTestV2FreeShippingMessage: 'As a Rouge member, you\'re getting FREE Fast Delivery.',

        shippingPanelTo: 'à',
        shippingPanelZipAriaLabel: 'Modifier l’emplacement de livraison',
        shippingPanelInfoAriaLabel: 'Détails de la politique d’expédition et de retour',
        shippingPanelBiPrefix: 'Les membres Beauty Insider profitent de l’ ',
        shippingPanelBiSuffix: 'expédition standard GRATUITE',

        // Pickup details panel (SHP-5238) — English placeholder, pending SDL translation
        storesNearYou: 'stores near you',
        pickupPanelAt: 'at',
        pickupPanelChangeStoreAriaLabel: 'Change pickup store',
        pickupPanelInfoAriaLabel: 'Buy Online & Pick Up details',
        inStorePickup: 'In-store pickup',
        curbsidePickup: 'Curbside pickup',
        curbsideConcierge: 'Curbside concierge',

        // Signed-out state (SHP-5258) — English placeholder, pending SDL translation
        signInLinkLabel: 'Sign in',
        createAccountLinkLabel: 'create an account',
        freeShippingSignInCardText: `${vars[0]} for`,
        freeShippingSignInAriaLabel: `${vars[0]} for ${vars[1]}`,
        shippingPanelSignInPrompt: `${vars[0]} or ${vars[1]} to enjoy ${vars[2]}`,

        // Nearby store availability row (SHP-5280) — English placeholder, pending SDL translation
        nearbyStores: 'nearby stores',
        nearbyStoresLinkAriaLabel: 'Check availability at nearby stores',

        // Auto-Replenish row
        autoReplenishRowSavePercent: `Enregistrer ${vars[0]}`,
        autoReplenishRowSuffix: ' avec le réapprovisionnement automatique',
        autoReplenishRowCheckboxAriaLabel: `Enregistrer ${vars[0]} grâce au réapprovisionnement automatique`,

        // Auto-Replenish expanded details (SHP-5122)
        deliveryEvery: 'Livrer chaque:',
        mostCommon: 'le plus courant',
        deliveryFrequencyLinkAriaLabel: 'Modifier la fréquence de livraison pour le réapprovisionnement automatique',
        autoReplenishRowNotEligible: 'Non admissible au réapprovisionnement automatique',
        autoReplenishLegalOptIn: 'By enrolling, you consent to the reoccurring charge for your subscription.',
        learnMore: 'En savoir plus',
        autoReplenishFirstTimeLegalShown: `*Les nouveaux abonnés obtiennent une réduction de ${vars[0]} sur leurs ${vars[1]} premières commandes, livrée dans les ${vars[2]} mois suivant la commande initiale. La période de promotion se termine le ${vars[3]}.`,
        autoReplenishFirstTimeLegalDetails: 'Détails',
        autoReplenishFirstTimeLegalMoreDetails: `Pour chaque produit en super aubaine, l’abonnement et le nombre d’unités sont limités à 1 par membre de la clientèle. Après ${vars[0]} commandes de réapprovisionnement à ${vars[1]} de réduction ou après ${vars[2]} mois à compter de la date d’inscription initiale, selon la première éventualité, l’abonnement est renouvelé à ${vars[3]} de réduction.`,

        fulfillmentMethodsGroupAriaLabel: 'Choisir une méthode d’expédition',
        outOfStockAt: `Out of Stock at ${vars[0]}`,
        checkOtherStores: 'Check other stores'
    };

    return resources[label];
}
